<ng-template [ngIf]="product">
    <a class="flex flex-col gap-2 group relative" [routerLink]="['/product', product.slug]">
        <!-- Product Image -->
        <div class="bg-surface rounded aspect-[4/5] overflow-hidden flex items-center justify-center">
            <img
                class="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
                alt=""
                [src]="product.productAsset | assetPreview:400"
            />
        </div>
        <!-- Product Info -->
        <div class="flex flex-col gap-1">
            <span class="text-disabled text-base">{{ product.productName?.split(' ')[0] }}</span>
            <span class="text-body text-lg leading-6">{{ product.productName }}</span>
        </div>
        <!-- Price -->
        <div class="flex items-center gap-2 flex-wrap">
            <span *ngIf="discountPercent > 0"
                  class="text-disabled text-sm line-through">
                {{ product.priceWithTax.min | formatPrice }}
            </span>
            <span class="text-primary font-semibold text-lg">
                {{ (discountedPrice ?? product.priceWithTax.min) | formatPrice }}
            </span>
            <span *ngIf="discountPercent > 0"
                  class="text-[10px] font-bold text-white bg-red-500 px-1.5 py-0.5 rounded">
                -{{ discountPercent }}%
            </span>
        </div>
        <!-- Favorite icon -->
        <button class="absolute top-2 right-2 w-8 h-8 flex items-center justify-center transition-colors"
                [class.text-primary]="inWishlist"
                [class.text-gray-400]="!inWishlist"
                [class.hover:text-primary]="!inWishlist"
                (click)="toggleWishlist($event)">
            <svg class="w-5 h-5" [attr.fill]="inWishlist ? 'currentColor' : 'none'" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"/>
            </svg>
        </button>
        <!-- Compare icon -->
        <button class="absolute top-12 right-2 w-8 h-8 flex items-center justify-center transition-colors"
                [class.text-primary]="inCompare"
                [class.text-gray-400]="!inCompare"
                [class.hover:text-primary]="!inCompare"
                [attr.aria-label]="'product.compareProduct' | translate"
                (click)="toggleCompare($event)">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 3v18M6.75 8.25h-3A.75.75 0 0 0 3 9v7.5a.75.75 0 0 0 .75.75h3a.75.75 0 0 0 .75-.75V9a.75.75 0 0 0-.75-.75Zm13.5 0h-3a.75.75 0 0 0-.75.75v7.5a.75.75 0 0 0 .75.75h3a.75.75 0 0 0 .75-.75V9a.75.75 0 0 0-.75-.75Z"/>
            </svg>
        </button>
    </a>
</ng-template>
